import { render } from "./EditProposalView.vue?vue&type=template&id=3b17eb4c"
import script from "./EditProposalView.vue?vue&type=script&lang=js"
export * from "./EditProposalView.vue?vue&type=script&lang=js"

import "./EditProposalView.vue?vue&type=style&index=0&id=3b17eb4c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__